// extracted by mini-css-extract-plugin
module.exports = {"Slick":"SlickSlider_Slick__33kZy"};